import SiteHeader from '@/pages/home/components/SiteHeader';
import Hero from '@/pages/home/components/Hero';
import FlashStream from '@/pages/home/components/FlashStream';
import StanceBoard from '@/pages/home/components/StanceBoard';
import ReversalTimeline from '@/pages/home/components/ReversalTimeline';
import FocusPoints from '@/pages/home/components/FocusPoints';
import PrActions from '@/pages/home/components/PrActions';
import TrustFaq from '@/pages/home/components/TrustFaq';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="overflow-hidden">
        <Hero />
        <FlashStream />
        <StanceBoard />
        <ReversalTimeline />
        <FocusPoints />
        <PrActions />
        <TrustFaq />
      </main>
      <SiteFooter />
    </div>
  );
}